import { Navigate } from 'react-router-dom';

import { getAuthToken } from '@/utils/localStorageUtil';

function PrivateRoute({ children, route }) {
  let auth = getAuthToken();
  return auth ? children : <Navigate to="/login" />;
}
export default PrivateRoute;
